module.exports = __webpack_public_path__ + "img/dea-formazione-ico-matematica.ed95b6dd.svg";